
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class AppButton extends Vue {
  @Prop({ type: String, default: "primary" })
  readonly variant!:
    | "primary"
    | "secondary"
    | "primary-outlined"
    | "secondary-outlined"
    | "text"
    | "danger"
    | "primary-secondary-gradient"
    | "transparent";

  @Prop({ type: Boolean, default: false }) readonly large!: boolean;
  @Prop({ type: Boolean, default: false }) readonly block!: boolean;
  @Prop({ type: Boolean, default: false }) readonly icon!: boolean;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
  @Prop({ type: Boolean, default: false }) readonly loading!: boolean;
  @Prop({ type: String, default: "1x" }) readonly iconSize!: string;

  @Prop({ type: [String, Array], default: "" }) readonly iconLeft!:
    | string
    | string[];
  @Prop({ type: [String, Array], default: "" }) readonly iconRight!:
    | string
    | string[];

  get isOutlined(): boolean {
    return this.variant.includes("outlined");
  }

  get isText(): boolean {
    return this.variant === "text";
  }
}
